module.exports = __webpack_public_path__ + "img/c_1.2a76b581.png";